import React from 'react'
import { Box } from '@mui/material'

/**
 * Drop-in for `react-spinners` ClimbingBoxLoader.
 */
export function ClimbingBoxLoader({
  color = '#000000',
  loading = true,
  size = 15,
  speedMultiplier = 1,
  cssOverride = {},
  style,
  ...rest
}) {
  if (!loading) return null

  const s = Math.max(6, Number(size) || 15)
  const speed = Math.max(0.1, Number(speedMultiplier) || 1)
  const duration = `${1 / speed}s`
  const box = s / 2

  return (
    <Box
      component="span"
      role="status"
      aria-label="loading"
      data-hf="climb"
      sx={{
        display: 'inline-block',
        position: 'relative',
        boxSizing: 'content-box',
        width: s * 2.5,
        height: s * 2.5,
        p: `${s * 0.3}px`,
        '@keyframes hfClimbWrapper': {
          '0%, 100%': { transform: 'translate(0, 0)' },
          '25%': { transform: 'translate(-100%, 0)' },
          '50%': { transform: 'translate(-100%, -100%)' },
          '75%': { transform: 'translate(0, -100%)' },
        },
        '@keyframes hfClimbBox': {
          '0%': { transform: 'translate(0, 0) rotate(0deg)' },
          '25%': { transform: 'translate(100%, 0) rotate(90deg)' },
          '50%': { transform: 'translate(100%, 100%) rotate(180deg)' },
          '75%': { transform: 'translate(0, 100%) rotate(270deg)' },
          '100%': { transform: 'translate(0, 0) rotate(360deg)' },
        },
        ...cssOverride,
        ...style,
      }}
      {...rest}
    >
      <Box
        component="span"
        sx={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: s,
          height: s,
          animation: `hfClimbWrapper calc(${duration} * 4) infinite cubic-bezier(0.23, 1, 0.32, 1)`,
        }}
      >
        <Box
          component="span"
          sx={{
            display: 'block',
            width: box,
            height: box,
            background: color,
            animation: `hfClimbBox ${duration} infinite cubic-bezier(0.23, 1, 0.32, 1)`,
          }}
        />
      </Box>
      <Box
        component="span"
        sx={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: s * 2,
          height: 2,
          background: color,
          opacity: 0.35,
        }}
      />
    </Box>
  )
}

export default ClimbingBoxLoader
